module.exports = __webpack_public_path__ + "img/rightbicep-ecto-mesomorph-male.320feb9a.svg";